import gql from 'graphql-tag';

export const GET_SALESPERSON_NAME = gql`
	query GetSalespersonNameForAgentTab($id: String!) {
		user(id: $id) {
			id
			name
		}
	}
`;
export const GET_SIGNED_UP_AGENTS = gql`
	query GetSignedUpUsers($q: JSON, $regionId: String, $salespersonId: String, $limit: Int, $offset: Int, $order: [[String]], $optOutAgents: [String]) {
		users(query: $q, salespersonId: $salespersonId, regionId: $regionId, limit: $limit, offset: $offset, order: $order, optOutAgents: $optOutAgents) {
			id
			name
			image
		}
	}
`;
